module.exports = __webpack_public_path__ + "img/slide11.bd501947.png";